import { createBrowserHistory } from 'history';

export default createBrowserHistory({ basename: BASE_URL });
